import { useQuery, useMutation } from '@apollo/client';
import React, { useContext } from 'react';
import UserContext from '../Context/UserContext';
import generateClientMutationId from '../../graphql/schema/generateClientMutationId';
import normalizeVariables from '../../graphql/schema/normalizeVariables';
import * as input from './inputComponents';

const ReferenceTableDropdown = (props) => {
  const { fieldName, entity, saveParameter, ...dropdownProps } = props;
  const { data, refetch } = useQuery(entity.default, { fetchPolicy: 'network-only' });
  const [saveEntity] = useMutation(entity.update);

  const {
    currentUser: {
      companyUser: { allowDynamicAttributeEntry = true },
    },
  } = useContext(UserContext);

  const onChange = (value) => {
    // Save new record
    if (allowDynamicAttributeEntry && value?.className === 'Select-create-option-placeholder') {
      const newRecord = data.defaultRecord;
      const updatedRecord = { ...newRecord, [fieldName]: value[fieldName] };
      saveEntity({
        variables: {
          input: {
            clientMutationId: generateClientMutationId(),
            [saveParameter]: normalizeVariables(updatedRecord),
          },
        },
      }).then((response) => {
        const dataKey = Object.keys(response.data)[0];
        const persistedRecord = response.data[dataKey].result;
        dropdownProps.onChange(persistedRecord);
        dropdownProps.refreshQuery();
        refetch();
      });
      return;
    }

    dropdownProps.onChange(value);
  };

  return <input.Dropdown {...dropdownProps} onChange={onChange} creatable={allowDynamicAttributeEntry} />;
};

ReferenceTableDropdown.displayName = 'Dropdown';
export default ReferenceTableDropdown;
